/* GeoDomeX theme - translations for German, French, Spanish, Italian and Dutch storefronts (21 Oct 2026), and American
   English for the US and Canada (24 Oct 2026).
   The theme is written in British English. On a de/fr/es/it/nl storefront the layout loads this file and the language's
   dictionary (gdxs-i18n-<lang>.js) at the end of <head>, before the page body, so every text node is translated as the
   browser builds the page and the shopper never sees English first. Exact strings match directly; strings with prices
   or numbers match a pattern ("Save {0}"), so prices stay exactly as Shopify formats them and plain numbers follow the
   language (3.5 m -> 3,5 m). Text that scripts render or change later is translated as it appears. Country names,
   form input and anything marked data-gdxs-notr are left alone.
   On US and Canadian English storefronts the layout names the American dictionary (window.GDXS_I18N_KEY = 'en-us'):
   our copy is rewritten word by word into American English (cart, color, backyard, shipping), metric sizes gain feet,
   and customer quotes are never touched. Shoppers paying in euros while reading English get English price formats
   (EUR 1,699.00 rather than EUR 1.699,00); in French Canada prices read 2 800 $. */
(function () {
  'use strict';
  var html = document.documentElement;
  var L = (html.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
  var D = window.GDXS_I18N && window.GDXS_I18N[window.GDXS_I18N_KEY || L];
  if (!D) return;
  var EN = L === 'en';
  var CUR = String(window.GDXS_CUR || '').toUpperCase();
  var EXACT = D.exact || {}, PAT = D.pattern || {};
  /* prices (symbol before or after), UK postcode areas, then plain numbers with separators */
  var TOK = /[£€$]\s?\d[\d.,  ']*\d|[£€$]\s?\d|\d[\d.,  ']*\d\s?(?:€|£|\$|kr|CHF|zł|Ft|lei)|\d\s?(?:€|£|\$)|\b[A-Z]{1,2}\d{1,2}[A-Z]?\b|\d+(?:[.,]\d+)*(?![A-Za-z\d]|[.,]\d)/g;
  var MONEY = /[€$]\s?\d[\d.,]*\d(?:\s?(?:EUR|CAD))?|[€$]\s?\d(?:\s?(?:EUR|CAD))?/g;
  var has = Object.prototype.hasOwnProperty;
  var LOC = { de: 'de-DE', fr: CUR === 'CAD' ? 'fr-CA' : 'fr-FR', es: 'es-ES', it: 'it-IT', nl: 'nl-NL' }[L] || (CUR === 'EUR' ? 'en-IE' : 'en-GB');
  var THOU = { de: '.', es: '.', it: '.', nl: '.', fr: ' ' }[L] || ',';
  function num(m) {
    if (EN) return m;
    if (/^\d{1,3}(,\d{3})+$/.test(m)) return m.replace(/,/g, THOU);
    if (/^\d+\.\d{1,2}$/.test(m)) return m.replace('.', ',');
    return m;
  }
  /* prices as the language writes them: "€1.699" -> "1.699 €" (fr "1 699 €"); in English, euro prices take English
     separators ("€1.699,00" -> "€1,699.00"); in French Canada dollar prices read "2 800 $" */
  function money(m) {
    var x = /^([€$])\s?(\d[\d.,]*\d|\d)(\s?(?:EUR|CAD))?$/.exec(m);
    if (!x) return m;
    var c = x[1] === '€' ? 'EUR' : (L === 'fr' && CUR === 'CAD' ? 'CAD' : '');
    if (!c || (EN && c !== 'EUR')) return m;
    var v = x[2], d = 0;
    if (c === 'CAD') { if (/\.\d{1,2}$/.test(v)) d = 2; v = v.replace(/,/g, ''); }
    else if (/,\d{1,2}$/.test(v)) { d = 2; v = v.replace(/\./g, '').replace(',', '.'); }
    else if (/\.\d{1,2}$/.test(v)) { d = 2; v = v.replace(/,/g, ''); }
    else v = v.replace(/[.,]/g, '');
    var n = parseFloat(v);
    if (!isFinite(n)) return m;
    /* 3 Nov 2026 (owner): prices without thousands separators in every language (1499 €, not 1.499 €) */
    try { return new Intl.NumberFormat(LOC, { style: 'currency', currency: c, minimumFractionDigits: d, maximumFractionDigits: d, useGrouping: false }).format(n) + (x[3] || ''); }
    catch (e) { return m; }
  }
  /* ---------- American English (US and Canada) ---------- */
  var RULES = [], WRE = null, KEEP = D.keep || [], FT = D.ft || {}, SQ = D.sq || {};
  if (EN) {
    (D.rules || []).forEach(function (r) { try { RULES.push([new RegExp(r[0], 'g'), r[1]]); } catch (e) {} });
    var wk = Object.keys(D.words || {}).sort(function (a, b) { return b.length - a.length; });
    if (wk.length) WRE = new RegExp('\\b(' + wk.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')\\b', 'gi');
  }
  function like(src, rep) {
    if (src.length > 1 && src === src.toUpperCase() && src !== src.toLowerCase()) return rep.toUpperCase();
    if (src.charAt(0) !== src.charAt(0).toLowerCase()) return rep.charAt(0).toUpperCase() + rep.slice(1);
    return rep;
  }
  /* metric sizes gain feet: 3.5 m -> 3.5 m (11′6″), 9.6 m² -> 9.6 m² (103 sq ft); never twice, never inside brackets.
     24 Oct 2026 (owner): nor when the page already shows feet beside it (the configurator's size cards print 8′10″ under
     2.7m). textNode() looks at the text's own small box (its parent and grandparent, 160 characters) for feet (NOM) or square
     feet (NOSQ) the page shows itself; the brackets this file adds are left out of that look, so sizes listed side by
     side still each gain theirs. */
  var NOM = false, NOSQ = false, GEN = null;
  function nearFeet(n) {
    if (!GEN) {
      var g = [], a;
      for (a in FT) if (has.call(FT, a)) g.push(String(FT[a]));
      for (a in SQ) if (has.call(SQ, a)) g.push(SQ[a] + ' sq ft');
      GEN = g.length ? new RegExp('\\s?\\((?:' + g.map(function (x) { return x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')\\)', 'g') : /$^/;
    }
    var e = n.parentElement, own = n.nodeValue;
    for (var k = 0; e && k < 2 && !(NOM && NOSQ); k++, e = e.parentElement) {
      var t = e.textContent || '';
      if (t.length > 160) break;
      t = t.replace(own, '').replace(GEN, '');
      if (/[′″]|\d\s?ft\b|\bfeet\b|\d'\s?\d/.test(t)) NOM = true;
      if (/sq ft/.test(t)) NOSQ = true;
    }
  }
  function feet(s) {
    if (/sq ft|[′″]|\d\s?ft\b|\bfeet\b/.test(s)) return s;
    return s.replace(/(\d+(?:\.\d+)?)\s?(m²|m)(?![A-Za-z²\d])/g, function (all, n, u, off) {
      var prev = s.slice(Math.max(0, off - 2), off), next = s.slice(off + all.length, off + all.length + 3);
      if (/\(\s?$/.test(prev) || /^\s?\(/.test(next) || next.charAt(0) === ')') return all;
      if (u === 'm²') return !NOSQ && has.call(SQ, n) ? all + ' (' + SQ[n] + ' sq ft)' : all;
      return !NOM && has.call(FT, n) ? all + ' (' + FT[n] + ')' : all;
    });
  }
  function american(t) {
    var o = t, i, kept = [];
    for (i = 0; i < KEEP.length; i++) if (o.indexOf(KEEP[i]) > -1) { o = o.split(KEEP[i]).join('\u0001' + kept.length + '\u0001'); kept.push(KEEP[i]); }
    for (i = 0; i < RULES.length; i++) o = o.replace(RULES[i][0], RULES[i][1]);
    if (WRE) o = o.replace(WRE, function (m) { var r = D.words[m.toLowerCase()]; return r == null ? m : like(m, r); });
    for (i = 0; i < kept.length; i++) o = o.split('\u0001' + i + '\u0001').join(kept[i]);
    if (D.ft) o = feet(o);
    return o;
  }
  function tr(s, ctx) {
    var t = s.replace(/\s+/g, ' ').trim();
    if (!t) return null;
    /* prices on their own ("+ €299", "€0,00 EUR") */
    if (!/[A-Za-z]/.test(t.replace(/\b(?:EUR|CAD)\b/g, ''))) {
      if (/[€$]\s?\d/.test(t)) { var mo = t.replace(MONEY, money); if (mo !== t) return mo; }
      if (EN) { var ft = D.ft ? feet(t) : t; return ft !== t ? ft : null; }
      if (/['′]/.test(t) && /^\d+\s?['′]\s?(\d+\s?["″])?$/.test(t)) return '';   /* feet and inches: metric only here */
      if (/^[\d.,\/\s+×%]+$/.test(t) && /\d\.\d|\d,\d{3}/.test(t)) { var o = t.replace(TOK, function (m) { return num(m); }); return o !== t ? o : null; }
      return null;
    }
    if (ctx && has.call(EXACT, ctx + '¦' + t)) return EXACT[ctx + '¦' + t];
    if (has.call(EXACT, t)) return EXACT[t];
    var toks = [], i = 0;
    var key = t.replace(TOK, function (m) { toks.push(m); return '{' + (i++) + '}'; });
    if (toks.length && has.call(PAT, key)) return PAT[key].replace(/\{(\d+)\}/g, function (_, k) { return toks[+k] != null ? money(num(toks[+k])) : ''; });
    if (EN) { var a = american(t); if (CUR === 'EUR') a = a.replace(MONEY, money); return a !== t ? a : null; }
    if (!/[A-Za-z]{2}/.test(t) && !/[£€$]/.test(t)) { var o2 = t.replace(/\s*\(\d+\s?['′]\s?\d*\s?["″]?\)/g, '').replace(/\d{1,3}(?:,\d{3})+(?!\d)|\d+\.\d{1,2}(?!\d)/g, num).replace(/(\d)m(?![A-Za-z\d])/g, '$1 m'); if (o2 !== t) return o2; }
    if (/[€$]\s?\d/.test(t)) { var o3 = t.replace(MONEY, money); if (o3 !== t) return o3; }
    return null;
  }
  var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE|TEXTAREA|svg)$/;
  var OUT = 'form[action*="localization"],[data-gdxs-notr],[contenteditable="true"]' + (EN && D.skip ? ',' + D.skip : '') + (EN && window.GDXS_I18N_SKIP ? ',' + window.GDXS_I18N_SKIP : '');
  var ATTR = ['placeholder', 'aria-label', 'alt', 'title'];
  function skipped(e) { return !e || SKIP.test(e.tagName) || !!(e.closest && e.closest(OUT)); }
  /* American English never rewrites a customer's words: text in quotation marks is theirs */
  function quoted(n) {
    if (!EN) return false;
    if (/^\s*[“"„«]/.test(n.nodeValue)) return true;
    var e = n.parentElement, s = e ? e.textContent || '' : '';
    if (s.length > 900) return false;
    s = s.replace(/\s+/g, ' ').trim();
    return /^[“"„«]/.test(s) && /[”"»]$/.test(s.replace(/[.,;:!?\s]+$/, ''));
  }
  /* a text box keeps what the shopper types, but its placeholder is ours to translate */
  function box(e) { return e && e.tagName === 'TEXTAREA' && !(e.closest && e.closest(OUT)); }
  /* a date like "23. Okt." already ends the sentence: drop the full stop that follows it */
  function dot(n) {
    if (EN) return;
    var v = n.nodeValue;
    if (v === '.') { var p = n.previousSibling; if (p && /\.\s*$/.test(p.textContent || '')) n.nodeValue = ''; return; }
    if (!/\.\s*$/.test(v)) return;
    var c = n, k = 0;
    while (c && !c.nextSibling && k++ < 3) c = c.parentNode;
    var s = c && c.nextSibling;
    if (s && s.nodeType === 3 && s.nodeValue === '.') s.nodeValue = '';
  }
  /* what we wrote last, per node and attribute, so our own output is never translated again */
  var DONE = typeof WeakMap === 'function' ? new WeakMap() : null;
  function done(n, k, v) { if (!DONE) return false; var d = DONE.get(n); if (v === undefined) return false; return !!d && d[k] === v; }
  function mark(n, k, v) { if (!DONE) return; var d = DONE.get(n); if (!d) { d = {}; DONE.set(n, d); } d[k] = v; }
  function textNode(n) {
    var v = n.nodeValue;
    if (!v || v.length > 2000) return;
    if (done(n, '#', v)) return;
    if (v === '.') { dot(n); return; }
    if (quoted(n)) return;
    var c = n.parentElement && n.parentElement.closest ? n.parentElement.closest('[data-i18n-ctx]') : null;
    if (EN && D.ft && /\d\s?m/.test(v)) nearFeet(n);
    var out = tr(v, c ? c.getAttribute('data-i18n-ctx') : '');
    NOM = NOSQ = false;
    if (out == null) { if (/\.\s*$/.test(v)) dot(n); return; }
    var lead = v.match(/^\s*/)[0], trail = v.match(/\s*$/)[0], nv = lead + out + trail;
    if (nv !== v) { mark(n, '#', nv); n.nodeValue = nv; }
    if (/\.\s*$/.test(nv)) dot(n);
  }
  function attrs(e) {
    for (var i = 0; i < ATTR.length; i++) {
      var v = e.getAttribute(ATTR[i]); if (!v || done(e, ATTR[i], v)) continue;
      var o = tr(v); if (o != null && o !== v) { mark(e, ATTR[i], o); e.setAttribute(ATTR[i], o); }
    }
    if (e.tagName === 'INPUT' && /^(submit|button)$/i.test(e.type) && e.value) { var o2 = tr(e.value); if (o2 != null && o2 !== e.value) e.value = o2; }
  }
  function walk(node) {
    if (!node) return;
    if (node.nodeType === 3) { if (!skipped(node.parentElement)) textNode(node); return; }
    if (node.nodeType === 1 && box(node)) { attrs(node); return; }
    if (node.nodeType !== 1 || skipped(node)) return;
    attrs(node);
    var w = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (n.nodeType === 1) { if (box(n)) attrs(n); return (SKIP.test(n.tagName) || (n.matches && n.matches(OUT))) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n; while ((n = w.nextNode())) { if (n.nodeType === 3) textNode(n); else attrs(n); }
  }
  var mo = new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var m = ms[i];
      if (m.type === 'childList') { for (var j = 0; j < m.addedNodes.length; j++) walk(m.addedNodes[j]); }
      else if (m.type === 'characterData') { if (!skipped(m.target.parentElement)) textNode(m.target); }
      else if (m.type === 'attributes') { if (!skipped(m.target) || box(m.target)) attrs(m.target); }
    }
  });
  mo.observe(html, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTR });
  /* safety pass once the document is parsed */
  function first() { walk(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', first); else first();
  /* for other scripts: T(english) gives the shopper's language, EN(text) gives back the English a translated text came from */
  var REV = null;
  function en(s) {
    s = String(s);
    if (!REV) { REV = {}; for (var k in EXACT) if (has.call(EXACT, k) && EXACT[k] && !has.call(REV, EXACT[k])) REV[EXACT[k]] = k.slice(k.indexOf('¦') + 1); }
    var t = s.replace(/\s+/g, ' ').trim();
    if (!t) return s;
    return has.call(REV, t) ? s.match(/^\s*/)[0] + REV[t] + s.match(/\s*$/)[0] : s;
  }
  function T(s, ctx) { s = String(s); var o = tr(s, ctx); return o == null ? s : s.match(/^\s*/)[0] + o + s.match(/\s*$/)[0]; }
  window.GDXS_T = T; window.GDXS_EN = en;
  window.GDXS = window.GDXS || {};
  window.GDXS.t = T;
})();
